import { Box } from "@mui/material"
import { useMemo } from "react"

export function MinHeightBox({ minHeight = 43, ...props }) {
    const sx = useMemo(
        () => ({ minHeight, display: "flex", flexDirection: "row", alignItems: "center", ...props.sx }),
        [props.sx, minHeight]
    )
    return <Box {...props} className="min-height-box" py={1} sx={sx} />
}
